<template>
  <div class="box">
    <o-table :items="trackerGeofences" :loading="loading" :draggable="true" @drop="updatePosition">
      <b-table-column v-slot="{ row }" field="name" label="Nom">
        {{ row.name }}
      </b-table-column>
      <b-table-column v-slot="{ row }" field="radius" label="Rayon">
        {{ row.radius ? `${row.radius}m` : '—' }}
      </b-table-column>
      <b-table-column v-slot="{ row }" field="liveCategoryIds" label="Catégories">
        <b-tooltip
          v-if="row.liveCategoryIds.length"
          position="is-bottom"
          multilined
          type="is-light"
        >
          {{ row.liveCategoryIds.length }}
          <b-icon icon="circle-info" size="is-small" type="is-info" />
          <template v-slot:content>
            {{ row.liveCategoryIds.map((id) => categoryNames[id]).join(', ') }}
          </template>
        </b-tooltip>
        <template v-else>—</template>
      </b-table-column>
      <b-table-column v-slot="{ row }" field="inTrackerInterval" label="Intervalle d'entrée">
        <b-tag>{{ trackerIntervalLabels[row.inTrackerInterval] }}</b-tag>
      </b-table-column>
      <b-table-column v-slot="{ row }" width="100">
        <div class="buttons are-small is-right">
          <b-button type="is-danger" :loading="loading" @click="geofenceToDelete = row">
            <b-icon icon="trash" />
          </b-button>
        </div>
      </b-table-column>
    </o-table>
    <o-modal
      title="Suppression d'un geofence"
      :isOpen="geofenceToDelete !== null"
      submit-label="Supprimer"
      variant="danger"
      @closeModal="geofenceToDelete = null"
      @confirmModalAction="remove"
    >
      <template>
        La suppression du geofence {{ geofenceToDelete?.name }} est <strong>définitive</strong>.
      </template>
    </o-modal>
  </div>
</template>

<script>
import OModal from '@components/Modal.vue'
import OTable from '@components/Table.vue'
import { mapActions } from 'vuex'
import { TRACKER_INTERVAL_LABELS } from '@constants/tracker/interval'

export default {
  name: 'LiveTrackerGeofenceTable',

  components: {
    OModal,
    OTable,
  },

  props: {
    trackerGeofences: {
      type: Array,
      required: true,
    },
    liveCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      geofenceToDelete: null,
    }
  },

  created() {
    this.trackerIntervalLabels = TRACKER_INTERVAL_LABELS
  },

  computed: {
    categoryNames() {
      return this.liveCategories.reduce((categories, category) => {
        return { ...categories, [category.id]: category.name }
      }, {})
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async updatePosition(droppedOnRowIndex, draggingRowIndex, geofence) {
      this.loading = true

      try {
        await this.$services.liveTrackerGeofenceService.update({
          ...geofence,
          location: {
            latitude: geofence.location[0],
            longitude: geofence.location[1],
          },
          position: droppedOnRowIndex,
        })

        const reordered = [...this.trackerGeofences]
        reordered.splice(draggingRowIndex, 1)
        reordered.splice(droppedOnRowIndex, 0, geofence)

        this.$emit(
          'update:trackerGeofences',
          reordered.map((geo, index) =>
            geo.position !== index ? { ...geo, position: index } : geo,
          ),
        )

        this.addToastMessage({
          text: `La position du geofence "${geofence.name}" a été modifiée.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ? err.message : 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    async remove() {
      this.loading = true

      if (!this.geofenceToDelete) {
        return
      }

      try {
        const liveTrackerGeofence = await this.$services.liveTrackerGeofenceService.delete(
          this.geofenceToDelete.id,
        )

        this.$emit(
          'update:trackerGeofences',
          this.trackerGeofences.filter((geofence) => geofence.id !== liveTrackerGeofence.id),
        )

        this.addToastMessage({
          text: `Le geofence "${liveTrackerGeofence.name}" a été supprimé.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text:
            err.message ?? `La suppression du geofence ${this.geofenceToDelete.name} a échouée.`,
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },
  },
}
</script>
